import { Article } from '@wix/ambassador-answers-search-proxy/types';

import { HARMONY_CATEGORY_IDS } from '../constants';
import { isMonthOldLaunchedFr } from './is-month-old-launched-fr';

const EXCLUDED_ARTICLE_IDS = [
  '8412d7b1-9650-4c1c-81d1-1111379c690d',
];

export const shouldAddNoIndex = (article?: Article): boolean => {
  if (!article) {
    return false;
  }

  // Check if article URL is in the excluded list
  if (article && article.id && EXCLUDED_ARTICLE_IDS.includes(article.id)) {
    return true;
  }

  // Check if it's a harmony article
  const isHarmonyArticle =
    article && HARMONY_CATEGORY_IDS.includes(article.categoryId || '') ||
    article.title?.toLowerCase().includes('wix harmony');

  // Check if it's an old feature request
  const noIndexDueToOldFR = article && isMonthOldLaunchedFr(article as any);

  // Check if excluded from help center content scope
  const isExcludedFromHelpCenter = article && article?.excludedFromHelpCenterContentScope;

  return (noIndexDueToOldFR || isExcludedFromHelpCenter || isHarmonyArticle) ?? false;
};
